import { ZmLoading } from '@zoom/zoom-ui-vue3'
import { DOM_IDS } from '../constants.js'
import { waitForElement } from '../dom-helpers.js'
import { createSubApp } from './create-sub-app.js'

const BILLING_CART_SCOPE = 'billing-cart'
const loadBillingCart = () => import('../components/billing-cart.vue')

function shouldDisplayPersistentCartV2() {
  return window?.microsDatas?.displayPersistentCartV2 === true
}

function getBillingCartHost(container) {
  const existing = document.getElementById(DOM_IDS.BILLING_CART)
  if (existing) return existing

  const host = document.createElement('div')
  host.id = DOM_IDS.BILLING_CART
  host.className = DOM_IDS.BILLING_CART
  host.style.display = 'flex'
  host.style.alignItems = 'center'
  host.style.marginLeft = '12px'
  container.appendChild(host)
  return host
}

export async function mountBillingCart() {
  try {
    if (!shouldDisplayPersistentCartV2()) return

    const rightContainer = await waitForElement(DOM_IDS.RIGHT_CONTAINER)
    if (!rightContainer) return

    const container = getBillingCartHost(rightContainer)
    if (container.__commonHeaderBillingCartApp) return

    const { default: BillingCart } = await loadBillingCart()
    container.__commonHeaderBillingCartApp = createSubApp({
      component: BillingCart,
      container,
      scope: BILLING_CART_SCOPE,
      plugins: [ZmLoading]
    })
  } catch (err) {
    console.error('[common-header][billing-cart] Mount failed:', err)
  }
}
